import React, { memo } from 'react';
export var RightTriangle = /*#__PURE__*/memo(function (_ref) {
  var fillColor = _ref.fillColor;
  return /*#__PURE__*/React.createElement("svg", {
    width: 43,
    height: 57,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, 'Triangle'), /*#__PURE__*/React.createElement("path", {
    d: "m42.951 28.22-42 28v-56z",
    fill: fillColor,
    fillRule: "evenodd"
  }));
});
export default RightTriangle;